<template>
  <v-container>
    <v-row class="text-center">
      
        <v-img src="/BannerMegalabs.png" class="my-3" contain height="100" />
        <v-img src="/cobranzasIcon.png" class="my-3" contain height="180" />
      <h1 class="display-2 font-weight-bold mb-3 primary--text">
          Sistema de Cobranzas
        </h1>
      
        
     
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HelloWorld",

  
};
</script>
